import React from "react";

import styles from './index.module.css';

const cx = require('classnames');

interface ImageItemProps {
  type?: 'item' | 'avatar';
  url?: string;
  is_whale?: boolean;
}

const ImageItem:React.FC<ImageItemProps> = (props) => {

  const { type = 'item', url, is_whale } = props;
  const [err, setErr] = React.useState(false);

  if (err || !url) {
    return null
  }

  const cls = styles[`image_${type}`];

  return <div className={cx({[styles.is_whale]: is_whale})}>
    <img className={cls} src={url} alt='' onError={() => {
    setErr(true);
  }} />
  </div>
}

export default ImageItem;